var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavingCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.393 10.262a1 1 0 0 1 .156 1.406l-4 5a1 1 0 0 1-1.421.143l-3-2.5a1 1 0 0 1 1.28-1.536l2.217 1.847 3.362-4.204a1 1 0 0 1 1.406-.156Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M6.25 20.043c-1.433 0-2.667-.517-3.7-1.55C1.517 17.46 1 16.226 1 14.793c0-1.3.413-2.446 1.237-3.437.825-.992 1.888-1.588 3.188-1.788.333-1.617 1.117-2.937 2.35-3.962 1.233-1.025 2.658-1.538 4.275-1.538 1.883 0 3.462.68 4.738 2.038 1.274 1.358 1.912 2.987 1.912 4.887v.6c1.2-.033 2.217.354 3.05 1.163.833.808 1.25 1.829 1.25 3.062 0 1.15-.417 2.142-1.25 2.975-.833.833-1.825 1.25-2.975 1.25H6.25Zm12.525-1.5c.75 0 1.392-.267 1.925-.8.533-.533.8-1.175.8-1.925s-.267-1.392-.8-1.925a2.624 2.624 0 0 0-1.925-.8H17.2v-2.1c0-1.483-.504-2.758-1.512-3.825-1.009-1.067-2.255-1.6-3.738-1.6s-2.733.533-3.75 1.6C7.183 8.235 6.675 9.51 6.675 10.993H6.2c-1.033 0-1.908.363-2.625 1.088-.717.725-1.075 1.62-1.075 2.687 0 1.033.366 1.92 1.098 2.663.732.741 1.616 1.112 2.652 1.112h12.525Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingCloud);
export default __webpack_public_path__ + "static/media/saving-cloud.e0146580.svg";
export { ForwardRef as ReactComponent };